import React from 'react';
import { Link } from 'react-router-dom';

import { CuroAppRoute } from 'enums/curo/CuroAppRoute';

import styles from './PoliciesPage.module.scss';

const GeneralContent = () => {
  const renderLinks = () => {
    return (
      <div className={styles.contentWrapper}>
        <div className={styles.formTitle}>Terms and Conditions</div>
        <a href={'/Privacy Notice.pdf'} target="_blank" title="Privacy Notice">
          Privacy Notice
        </a>
        <Link to={CuroAppRoute.OnlinePrivacyPolicy} title="Online Privacy Policy">
          Online Privacy Policy
        </Link>
        <Link to={CuroAppRoute.TermsOfUse} title="Terms of Use">
          Terms of Use
        </Link>
        <Link
          to={CuroAppRoute.ConsentForElectronicSignatures}
          title="Consent for Electronic Signatures"
        >
          Consent for Electronic Signatures
        </Link>
      </div>
    );
  };

  return renderLinks();
};

export default GeneralContent;
